function intersectBounds(b1, b2) {
  return !(b1._southWest.lat > b2._northEast.lat || b1._northEast.lat < b2._southWest.lat || b1._southWest.lng > b2._northEast.lng || b1._northEast.lng < b2._southWest.lng);
}

function boundsCentre(b) {
  return { lat: (b._southWest.lat + b._northEast.lat) /2, lng: (b._southWest.lng + b._northEast.lng) /2 };
}

// assumes a square earth
function calcDistance(pt1, pt2) {
  return (pt1.lat-pt2.lat)*(pt1.lat-pt2.lat) + (pt1.lng-pt2.lng)*(pt1.lng-pt2.lng)
}

function furthestCentre(area, areas) {
  const myCentre = boundsCentre(area.bounds);
  return areas.reduce ((furthest, a) => {
    const thisCentre = boundsCentre(a.bounds)
    const distance = calcDistance(myCentre, thisCentre)
    if ( distance > furthest.distance ) {
      return { area: a, distance: distance}
    } else {
      return furthest;
    }
  } , { area: null, distance: 0})
}

/**
 * msg.data.fillColors    Array of hexcolor strings to use for recoloring, all areas should be colored one of these colors
 * 
 */
onmessage = function(msg) {
  var allBounds = [];
  var layers = msg.data.layers;
  var fillColors = msg.data.fillColors;
  var numColors = fillColors.length;
  var changes = [];
  layers.forEach(function(l) {
    var borderingAreas = allBounds.filter(function(b) { 
      return intersectBounds(b.bounds, l.bounds); 
    });
    var borderColors = borderingAreas.map(function(a) { return a.color; });
    var color = l.color;
    var colorCounter = fillColors.indexOf(color);
    if (colorCounter === -1) {
      color = fillColors[0];
      colorCounter = 0;
    }
    var innerCount = 0;
    while (innerCount < numColors && borderColors.indexOf(color) != -1) {
      color = fillColors[(colorCounter ++) % numColors];
      innerCount ++;
    }
    if (innerCount === numColors) {
      const furthestNeighbour = furthestCentre(l, borderingAreas);
      console.log('Couldn\'t find an unused color for ' + l.feature.properties.name + ' size ' + calcDistance(l.bounds._southWest, l.bounds._northEast) + ' it has ' + borderingAreas.length + ' neighbours - trying furthest neighbour ' + furthestNeighbour.area.name);
      console.log(borderingAreas.map(a => a.name));
      color = furthestNeighbour.area.color;
    }
    if (l.color !== color) {
      changes.push({
        id: l.id, newColor: color
      });
    //  console.log('Color changed for ' + l.feature.properties.name + ' from ' + l.color + ' to ' + color);
    }
    allBounds.push({
      name:l.feature.properties.name, 
      bounds:l.bounds, 
      color: color
    });

  });
  postMessage(changes);
};